<div class="account-activation-page">
  <!-- Arrière-plan animé -->
  <div class="animated-background">
    <!-- Cercles décoratifs -->
    <div class="decorative-circles">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
    </div>

    <!-- Particules lumineuses -->
    <div class="light-particles">
      <div class="light-particle particle-1"></div>
      <div class="light-particle particle-2"></div>
      <div class="light-particle particle-3"></div>
      <div class="light-particle particle-4"></div>
      <div class="light-particle particle-5"></div>
      <div class="light-particle particle-6"></div>
    </div>

    <!-- Icônes flottantes -->
    <div class="floating-icons">
      <i class="fas fa-check-circle icon-1"></i>
      <i class="fas fa-envelope-open icon-2"></i>
      <i class="fas fa-shield-alt icon-3"></i>
      <i class="fas fa-user-check icon-4"></i>
    </div>
  </div>

  <div class="container activation-container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-lg-6 col-md-8 col-sm-10">

        <!-- État : Vérification en cours -->
        <div class="activation-card card-custom fade-in-up text-center" *ngIf="verifying">
          <div class="spinner-wrapper mb-4">
            <div class="spinner-border text-primary-color" role="status">
              <span class="visually-hidden">Vérification...</span>
            </div>
          </div>
          <h2 class="mb-3">Vérification en cours...</h2>
          <p class="text-secondary">
            Nous vérifions votre lien d'activation, veuillez patienter
          </p>
          <div class="loading-dots mt-3">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <!-- État : Activation réussie -->
        <div class="activation-card card-custom fade-in-up text-center" *ngIf="!verifying && success">
          <div class="success-icon-wrapper mb-4">
            <i class="fas fa-check-circle"></i>
            <div class="success-particles">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <h1 class="mb-3">Compte activé avec succès !</h1>
          <p class="text-secondary mb-4">
            Félicitations ! Votre compte a été activé avec succès.
            <br>
            Vous pouvez maintenant profiter de tous nos services.
          </p>

          <!-- Avantages -->
          <div class="benefits-list mb-4">
            <div class="benefit-item">
              <i class="fas fa-check text-primary-color me-2"></i>
              <span>Accès aux signaux de trading premium</span>
            </div>
            <div class="benefit-item">
              <i class="fas fa-check text-primary-color me-2"></i>
              <span>Formations crypto et forex exclusives</span>
            </div>
            <div class="benefit-item">
              <i class="fas fa-check text-primary-color me-2"></i>
              <span>Support communautaire 24/7</span>
            </div>
          </div>

          <!-- Redirection automatique -->
          <div class="redirect-info mb-4">
            <div class="countdown-circle">
              <span class="countdown-number">{{ redirectCountdown }}</span>
            </div>
            <p class="text-secondary small mb-0 mt-2">
              <i class="fas fa-info-circle me-1"></i>
              Redirection automatique dans {{ redirectCountdown }} seconde{{ redirectCountdown > 1 ? 's' : '' }}
            </p>
          </div>

          <!-- Bouton d'action -->
          <button class="btn btn-primary-custom btn-lg" (click)="goToLogin()">
            <i class="fas fa-sign-in-alt me-2"></i>
            Se connecter maintenant
          </button>

          <!-- Section sécurité -->
          <div class="security-info text-center mt-4">
            <p class="text-secondary small mb-0">
              <i class="fas fa-lock text-primary-color me-1"></i>
              Vos données sont protégées par un cryptage de niveau bancaire
            </p>
          </div>
        </div>

        <!-- État : Erreur (lien invalide ou expiré) -->
        <div class="activation-card card-custom fade-in-up text-center" *ngIf="!verifying && !success && errorMessage">
          <div class="error-icon-wrapper mb-4">
            <i class="fas fa-times-circle"></i>
          </div>

          <h1 class="mb-3">Erreur d'activation</h1>
          <p class="text-secondary mb-4">
            {{ errorMessage }}
          </p>

          <!-- Alert danger -->
          <div class="alert alert-danger mb-4" role="alert">
            <i class="fas fa-exclamation-triangle me-2"></i>
            Le lien d'activation est invalide, a expiré ou a déjà été utilisé.
          </div>

          <!-- Solutions proposées -->
          <div class="solutions-box mb-4">
            <h5 class="mb-3">
              <i class="fas fa-question-circle text-primary-color me-2"></i>
              Que faire ?
            </h5>
            <div class="solution-item">
              <i class="fas fa-check-circle text-primary-color me-2"></i>
              <span>Vérifiez que vous utilisez le dernier email d'activation reçu</span>
            </div>
            <div class="solution-item">
              <i class="fas fa-check-circle text-primary-color me-2"></i>
              <span>Les liens d'activation expirent après 24 heures</span>
            </div>
            <div class="solution-item">
              <i class="fas fa-check-circle text-primary-color me-2"></i>
              <span>Demandez un nouveau lien d'activation si nécessaire</span>
            </div>
          </div>

          <!-- Boutons d'action -->
          <div class="action-buttons">
            <button class="btn btn-primary-custom me-2 mb-2" (click)="goToResendVerification()">
              <i class="fas fa-paper-plane me-2"></i>
              Renvoyer un lien d'activation
            </button>
            <button class="btn btn-outline-custom mb-2" (click)="goToLogin()">
              <i class="fas fa-arrow-left me-2"></i>
              Retour à la connexion
            </button>
          </div>
        </div>

        <!-- Section aide -->
        <div class="help-section text-center mt-4 fade-in" *ngIf="!verifying">
          <p class="text-secondary small mb-2">
            <i class="fas fa-question-circle me-1"></i>
            Besoin d'aide ?
          </p>
          <div class="help-links">
            <a routerLink="/contact" class="text-primary-color me-3">
              <i class="fas fa-life-ring me-1"></i>
              Support
            </a>
            <a routerLink="/faqs" class="text-primary-color me-3">
              <i class="fas fa-question me-1"></i>
              FAQ
            </a>
            <a routerLink="/contact" class="text-primary-color">
              <i class="fas fa-envelope me-1"></i>
              Contact
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <footer class="activation-footer" *ngIf="!verifying">
    <div class="container">
      <p class="text-center text-secondary small mb-0">
        © {{ currentYear }} SappTradingPro. Tous droits réservés.
      </p>
    </div>
  </footer>
</div>
